import actions from "./actions";

export default {
  namespaced: true,
  state: () => ({
    banners: [],
    collections: [],
    categories: [],
    conferences: [],
    conference: {},
    lesson: {},
    lessons: [],
    conferencesRelated: [],
    allConferences: [],
    homeConferences: [],
    conferenceContent: [],
    my_list: [],
  }),
  mutations: {
    setConferenceContent(state, data) {
      state.conferenceContent = data;
    },
    setHomeConferences(state, conferences) {
      state.homeConferences = conferences;
    },
    setBanners(state, banners) {
      state.banners = banners;
    },
    setConference(state, conference) {
      state.conference = conference;
    },
    setConferencesRelated(state, conferences) {
      state.conferencesRelated = conferences;
    },
    setLesson(state, lesson) {
      state.lesson = lesson;
    },
    setLessons(state, lessons) {
      state.lessons = lessons;
    },
    setCollections(state, collections) {
      state.collections = collections;
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setConferences(state, conferences) {
      state.conferences.push({
        id: conferences[0].category.id,
        items: conferences,
      });
    },
    setAllConferences(state, conferences) {
      state.allConferences = conferences;
    },
    setMyList(state, my_list) {
      state.my_list = my_list;
    },
  },

  actions,
};
